import { createRouter, createWebHistory } from 'vue-router'

import Widget from '../components/Widget.vue'

const routes = [
  {
    path: '/',
    name: 'Widget',
    component: Widget
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: '/v1',
  routes
})

export default router
